import { UserNavigation } from "./UserNavigation";

export default UserNavigation;
